import { api } from "../../../services/rpc/RpcProvider";
import { useToast } from "@introist/react-foundation/v2";

export const useAutomationResources = (automationId: string) => {
  const { data: resources } = api.automations.resources.list.useQuery({ automationId });

  return { resources };
};

export const useAutomationResourceActions = () => {
  const toast = useToast();

  const addOp = api.automations.resources.add.useMutation();
  const removeOp = api.automations.resources.remove.useMutation();

  const apiUtils = api.useContext();

  const listOp = apiUtils.automations.resources.list;

  const addResource = async (automationId: string, resourceIdentifier: string) => {
    const res = await addOp.mutateAsync({ automationId, resourceId: resourceIdentifier });
    await listOp.refetch({ automationId });
    toast.success("Resource added to automation");

    return res;
  };

  const removeResource = async (automationId: string, resourceIdentifier: string) => {
    await removeOp.mutateAsync({ automationId, resourceId: resourceIdentifier });
    await listOp.refetch({ automationId });
    toast.success("Resource removed");
  };

  return { addResource, removeResource };
};
